import { Space, Tag, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { currentIntlLocale } from '@/app/i18n'
import { formatLedgerAmount } from './ledgerAmount'
import { formatJournalAmount } from './ledgerJournalApi'
import { LedgerOwnerName } from './LedgerOwnerName'
import type { LedgerFinding } from './ledgerApi'

// `ReconciliationRepository` subject'ni shu shakllarda yozadi; qolgani serverning o'zbekcha matni.
const ACCOUNT_SUBJECT = /^([A-Z_]+):([0-9a-fA-F-]{36}):([A-Z_]+):([A-Za-z]+)$/
const TXN_SUBJECT = /^txn=(\d+) birlik=(\S+)$/
const UNIT_SUBJECT = /^birlik=(\S+)$/
const ENTRY_SUBJECT = /^entry=(\d+)$/

export function ReconciliationFinding({ finding }: { finding: LedgerFinding }) {
  const { t } = useTranslation()
  const account = ACCOUNT_SUBJECT.exec(finding.subject)
  const txn = TXN_SUBJECT.exec(finding.subject)
  const entry = ENTRY_SUBJECT.exec(finding.subject)
  const unitOnly = UNIT_SUBJECT.exec(finding.subject)
  const unit =
    account?.[4]
    ?? txn?.[2]
    ?? unitOnly?.[1]
    ?? (finding.check === 'TRAFFIC_CHAIN' ? 'BYTE' : null)

  const amount = (value: number) => {
    if (unit === null) return value.toLocaleString(currentIntlLocale())
    if (unit.toUpperCase() === 'BYTE') return formatJournalAmount({ amount: value, unit, money: false })
    return formatLedgerAmount(value, unit)
  }
  const values = { expected: amount(finding.expected), actual: amount(finding.actual) }

  let subject = null
  if (account) {
    const [, ownerType = '', ownerId = '', accountType = ''] = account
    subject = (
      <Space size={4} wrap>
        <LedgerOwnerName type={ownerType} id={ownerId} />
        <Tag>{t(`ledgerAccountType.${accountType}`, { defaultValue: accountType })}</Tag>
      </Space>
    )
  } else if (txn) {
    subject = t('ledger.reconciliation.subject.txn', { id: txn[1] })
  } else if (entry) {
    subject = t('ledger.reconciliation.subject.entry', { id: entry[1] })
  } else if (unitOnly === null && t('common.langCode') === 'uz') {
    subject = finding.subject
  }

  return (
    <Space direction="vertical" size={0}>
      <Typography.Text strong style={{ fontSize: 12 }}>
        {t(`ledger.reconciliation.check.${finding.check}`, {
          defaultValue: t('ledger.reconciliation.check.unknown'),
        })}
      </Typography.Text>
      {subject === null ? null : <span style={{ fontSize: 12 }}>{subject}</span>}
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {t(`ledger.reconciliation.detail.${finding.check}`, {
          ...values,
          defaultValue: t('ledger.reconciliation.detail.default', values),
        })}
      </Typography.Text>
    </Space>
  )
}
